/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Task } from '../models/Task';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FantaTaskService {
    /**
     * Create Missing Match Days For League
     * @param leagueId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createMissingMatchDays(
        leagueId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_task/missing_match_days/{league_id}',
            path: {
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create All Missing Match Days
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createAllMissingMatchDays(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_task/missing_match_days_all',
        });
    }
    /**
     * Create Missing Ratings
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createMissingRatings(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_task/missing_ratings',
        });
    }
    /**
     * Move League
     * Move a league to a new season.
     * This is a placeholder function and should be implemented with actual logic.
     * @param amountDays
     * @param leagueId
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static moveLeague(
        amountDays: number,
        leagueId: number,
    ): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_task/move_league',
            query: {
                'amount_days': amountDays,
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Random Lineup
     * Create a random lineup for a given fanta team and match day.
     * This is a placeholder function and should be implemented with actual logic.
     * @param fantaTeamId
     * @param matchDay
     * @returns any Successful Response
     * @throws ApiError
     */
    public static generateRandomLineup(
        fantaTeamId: number,
        matchDay: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_task/generate_random_lineup',
            query: {
                'fanta_team_id': fantaTeamId,
                'match_day': matchDay,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Random Team
     * Create a random team for a given fanta team and match day.
     * This is a placeholder function and should be implemented with actual logic.
     * @param fantaTeamId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static fillTeamWithRandomPlayers(
        fantaTeamId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_task/fill_team_with_random_players',
            query: {
                'fanta_team_id': fantaTeamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Send End Match Day Notification
     * Create a random team for a given fanta team and match day.
     * This is a placeholder function and should be implemented with actual logic.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static sendEndMatchDayNotification(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_task/send_end_match_day_notification',
        });
    }
    /**
     * @deprecated
     * Generate Random Team And Add To Group
     * @param leagueId
     * @param fantaTeamName
     * @param fantaGroupId
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static generateRandomFantaTeam(
        leagueId: number,
        fantaTeamName: string,
        fantaGroupId?: (number | null),
    ): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_task/generate_random_team_and_add_to_group',
            query: {
                'league_id': leagueId,
                'fanta_team_name': fantaTeamName,
                'fanta_group_id': fantaGroupId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Multiple Fanta Teams
     * @param amount
     * @param fantaGroupId
     * @param leagueId
     * @param randomJersey
     * @param teamNamePrefix
     * @returns Task Successful Response
     * @throws ApiError
     */
    public static generateMultipleFantaTeams(
        amount: number,
        fantaGroupId?: (number | null),
        leagueId?: (number | null),
        randomJersey: boolean = true,
        teamNamePrefix?: (string | null),
    ): CancelablePromise<Task> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_task/generate_multiple_fanta_teams',
            query: {
                'amount': amount,
                'fanta_group_id': fantaGroupId,
                'league_id': leagueId,
                'random_jersey': randomJersey,
                'team_name_prefix': teamNamePrefix,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
